import fetchV2 from "auth/FetchInterceptorV2";
import { env } from "configs/EnvironmentConfig";

const routeService = {};

// List Route
routeService.listRoute = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  const defaultFields = [
    "id",
    "name",
    "code",
    "note",
    // "phone_number",
    // "address",
    // "ward_code",
    // "district_code",
    // "province_code",
    "description",
    "maker_id",
    "maker_date",
    "maker.id",
    "maker.display_name",
    "checker_id",
    "checker_date",
    "checker.id",
    "checker.display_name",
    "record_status",
    "tenant_code",
  ];

  return fetchV2({
    url: `${env.API_MSP}/routes`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      keywords: params.keywords || "",
      expand: params.expand || "maker,checker",
      fields: params.fields || defaultFields.join(","),
    },
  });
};

// Create Route
routeService.createRoute = data => {
  return fetchV2({
    url: `${env.API_MSP}/routes`,
    method: "post",
    data: {
      ...data,
    },
  });
};

// Detail Route
routeService.detailRoute = ({
  routeId,
  params = { expand: undefined, fields: undefined },
}) => {
  return fetchV2({
    url: `${env.API_MSP}/routes/${routeId}`,
    method: "get",
    params: {
      ...params,
      expand: params.expand || undefined,
      fields: params.fields || undefined,
    },
  });
};

// Update Route
routeService.updateRoute = ({ routeId = undefined, data = {} }) => {
  return fetchV2({
    url: `${env.API_MSP}/routes/${routeId}`,
    method: "put",
    data: {
      ...data,
    },
  });
};

// Delete Route
routeService.deleteRoute = ({ routeId = undefined }) => {
  return fetchV2({
    url: `${env.API_MSP}/routes/${routeId}`,
    method: "delete",
  });
};

// Active Route
routeService.activeRoute = ({ routeId = undefined, data = {} }) => {
  return fetchV2({
    url: `${env.API_MSP}/routes/${routeId}`,
    method: "put",
    data: {
      ...data,
    },
  });
};

// clearAllRoute
routeService.clearAllRoute = () => {
  return fetchV2({
    url: `${env.API_MSP}/route-localities/clear-data`,
    method: "delete",
  });
};
// clearRouteOfHub
routeService.clearRouteOfHub = ({ hub_id }) => {
  return fetchV2({
    url: `${env.API_MSP}/route-localities/clear-data/${hub_id}`,
    method: "delete",
  });
};

export default routeService;
